<script>
import { CdrBreakpointLg, CdrBreakpointSm } from '@rei/cdr-tokens';
import { ScrollCarousel } from '@rei/recommendations-slider';
import LeadRailCard from './LeadRailCard.vue';

export default {
  name: 'LeadRail',
  components: {
    LeadRailCard,
    ScrollCarousel,
  },
  props: {
    slidesData: { type: Array, required: false, default: () => [] },
  },
  data() {
    return {
      slidesToShow: 2,
      slidesToScroll: 1,
      slidesGap: 2,
    };
  },
  computed: {
    slides() {
      return this.slidesData.map((item, idx) => ({
        key: idx.toString(),
        props: {
          ...item,
          highPriority: idx < 4,
        },
      }));
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      const clientWidth = window.innerWidth;

      switch (true) {
        case clientWidth < Number(CdrBreakpointSm):
          this.slidesToShow = 1;
          break;
        case clientWidth < Number(CdrBreakpointLg):
          this.slidesToShow = 2;
          break;
        default:
          this.slidesToShow = 3;
          break;
      }
    },
  },
};
</script>
<template>
  <div
    class="lead-rail"
    data-ui="lead-rail"
  >
    <h1 class="sr-only">{{ slides[0].props?.content.heading.text }}</h1>
    <scroll-carousel
      id="lead-rail"
      class="lead-rail"
      :slides="slides"
      :slides-gap="slidesGap"
      :slides-to-show="slidesToShow"
      :slides-to-scroll="slidesToScroll"
      :is-showing-arrows="true"
    >
      <template #slide="slideProps">
        <lead-rail-card
          :key="slideProps.key"
          :content="slideProps.content"
          :visual-configuration="slideProps.visualConfiguration"
          :high-priority="slideProps.highPriority"
        />
      </template>
    </scroll-carousel>
  </div>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

:deep(.scroll-carousel__arrow--left) {
  left: $cdr-space-two-x;
}
:deep(.scroll-carousel__arrow--right) {
  right: $cdr-space-two-x;
}

:deep(.scroll-carousel__viewport) {
  padding: 0;
  border-radius: 0;
}
</style>
